import { render, staticRenderFns } from "./yueke3.vue?vue&type=template&id=47133ae8&scoped=true"
import script from "./yueke3.vue?vue&type=script&lang=js"
export * from "./yueke3.vue?vue&type=script&lang=js"
import style0 from "./yueke3.vue?vue&type=style&index=0&id=47133ae8&prod&scoped=true&lang=css"
import style1 from "./yueke3.vue?vue&type=style&index=1&id=47133ae8&prod&lang=scss&scoped=true"
import style2 from "./yueke3.vue?vue&type=style&index=2&id=47133ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47133ae8",
  null
  
)

export default component.exports